export enum BUTTON_VARIANTS {
    APPLE = 'apple',
    BLACK = 'black',
    FACEBOOK = 'facebook',
    FACEBOOK_LIGHT = 'facebook-light',
    FACEBOOK_LIGHT_TEST = 'facebook-light-test',
    GREEN = 'green',
    NO_BORDER = 'no-border',
    PINK = 'pink',
    PRIMARY = 'primary-button',
    RED = 'red',
    ROUNDED = 'rounded',
    SMALL = 'small',
    TAG = 'tag',
    TAG_ACTIVE = 'tag-active',
    SECONDARY = 'secondary',
    WHITE = 'white',
    YELLOW = 'yellow',
    INTERACTIVE_PRIMARY = 'interactive-primary',
    INTERACTIVE_SECONDARY = 'interactive-secondary',
    INTERACTIVE_TERTIARY = 'interactive-tertiary',
    PLAIN_LINK = 'plain-link'
}

export enum BUTTON_TYPES {
    BUTTON = 'button',
    ICON = 'icon',
    ICON_BUTTON = 'icon-button'
}
